module.exports = __webpack_public_path__ + "img/swap.047c7f92.gif";